import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleNames } from '../models/users';

@Pipe({
  name: 'userRole'
})
export class UserRolePipe implements PipeTransform {

  transform(value: number): any {
    switch (value) {
      case 0:
        return UserRoleNames.GlobalAdmin
      case 1:
        return UserRoleNames.DeploymentAdmin
      case 2:
        return UserRoleNames.PowerUser
      case 3:
        return UserRoleNames.JobOperator
      case 4:
        return UserRoleNames.Reader;
    }
  }
}
